import { useCallback } from 'react';

import type {
    FeatureRouteConfig,
    NavigateOptionsWithOptionalBase,
    QueryParametersOptions,
} from './FeatureNavigateTypes';
import { useCreateUrlFromRootMap } from './useCreateUrlFromRootMap';
import { createUnsafeLinkPath } from '../createLinkPath';

export type UseFeatureLinkHrefReturnType<RouteConfig extends FeatureRouteConfig> = <
    Path extends RouteConfig['paths'],
>(
    path: Path,
    ...[options]: NavigateOptionsWithOptionalBase<
        RouteConfig['baseUrl'],
        Path,
        QueryParametersOptions
    >
) => string;

export function useFeatureLinkHref<FeatureId extends never>(
    featureId: FeatureId,
): UseFeatureLinkHrefReturnType<any> {
    const createUrlFromRootMap = useCreateUrlFromRootMap(featureId);

    return useCallback(
        (path, ...[options]) => {
            const { queryParameters = {}, ...withoutQueryParameters } = options ?? {};
            return createUnsafeLinkPath(
                createUrlFromRootMap(path, {
                    pathParameters: withoutQueryParameters,
                    queryParameters,
                }),
            );
        },
        [createUrlFromRootMap],
    );
}
